import PropTypes from "prop-types"
import { useRegistrationListContext } from "../../../registration/list/RegistrationListContainer"
import {
  ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES,
  ENROLLMENT_CONTROL_FILTER_BY_ROLE_OBSERVER,
  ENROLLMENT_CONTROL_FILTER_BY_ROLE_STUDENT,
  ENROLLMENT_CONTROL_FILTER_BY_STAFF_ROLES,
  ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE,
  ENROLLMENT_CONTROL_SORT_BY_DATE_JOINED,
  FILTERS,
  SORTS
} from "../../../registration/list/utils"
import CommunityAreaFilter from "../CommunityAreaFilter"

const getControlFilterLabel = (filter, translator) => {
  switch (filter) {
    case ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES:
      return {
        title: translator("Members")
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_STUDENT:
      return {
        title: translator("Learners")
      }
    case ENROLLMENT_CONTROL_FILTER_BY_STAFF_ROLES:
      return {
        title: translator("Staff")
      }
    case ENROLLMENT_CONTROL_FILTER_BY_ROLE_OBSERVER:
      return {
        title: translator("Observers")
      }
  }
}

const getControlSortLabel = (sort, translator) => {
  switch (sort) {
    case ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE:
      return {
        title: translator("Recently active")
      }
    case ENROLLMENT_CONTROL_SORT_BY_DATE_JOINED:
      return {
        title: translator("Recently joined")
      }
  }
}

// controlled component
const CommunityMembersFilter = ({ inverted, children }) => {
  const { filter, sort, onFilter, onSort } = useRegistrationListContext()
  return (
    <CommunityAreaFilter
      filter={filter}
      filters={FILTERS}
      onFilter={onFilter}
      sort={sort}
      sorts={SORTS}
      onSort={onSort}
      getControlFilterLabel={getControlFilterLabel}
      getControlSortLabel={getControlSortLabel}
      inverted={inverted}
    >
      {children}
    </CommunityAreaFilter>
  )
}

CommunityMembersFilter.displayName = "CommunityMembersFilter"

CommunityMembersFilter.propTypes = {
  inverted: PropTypes.bool
}

export default CommunityMembersFilter
